import { AdmissionGroup, AdmissionGroupItem } from '@domain/admission-group';
import { EventSection, EventSectionItem } from '@domain/event-section';

import { MoveOfferType } from '../../../hooks/admissions/use-move-offer';

export const moveOfferItemToPosition = (
  to: { type: MoveOfferType; id: string },
  toPosition: number,
  itemToMove: EventSectionItem | AdmissionGroupItem,
  sections: EventSection[],
  groups: AdmissionGroup[]
): void => {
  if (to.type === 'section') {
    const toSection = sections.find((s) => s.id === to.id);
    if (toSection) {
      toSection.items.splice(toPosition, 0, itemToMove as EventSectionItem);
    }
  } else if (to.type === 'offer_group') {
    const toGroup = groups.find((g) => g.id === to.id);
    if (toGroup) {
      toGroup.items.splice(toPosition, 0, itemToMove as AdmissionGroupItem);
    }
  }
};
